 import { Button } from "@/components/ui/button";
 import { ArrowRight, Phone, MessageSquare } from "lucide-react";
 import { motion } from "framer-motion";
 import { Link } from "react-router-dom";
 import { trackCTA } from "@/lib/trackCTA";
 
 export function CTASection() {
   return (
     <section className="py-16 md:py-24 bg-background">
       <div className="container">
         <motion.div
           initial={{ opacity: 0, y: 20 }}
           whileInView={{ opacity: 1, y: 0 }}
           viewport={{ once: true }}
           className="relative overflow-hidden rounded-3xl bg-gradient-hero p-8 md:p-12 lg:p-16"
         >
           {/* Background pattern */}
           <div className="absolute inset-0 opacity-5">
             <div className="absolute inset-0" style={{
               backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
             }} />
           </div>
 
           <div className="relative grid lg:grid-cols-2 gap-8 lg:gap-12 items-center">
             {/* Content */}
             <div>
               <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-primary-foreground mb-4">
                 Ready to Optimize Your
                 <span className="text-accent"> Warehouse?</span>
               </h2>
               <p className="text-lg text-primary-foreground/80 mb-8 max-w-xl">
                 Submit a request and we'll contact you within 24 hours. Our experts will help you find the perfect racking solution—whether you need new systems, quality used equipment, or a complete warehouse redesign.
               </p>
 
                <div className="flex flex-col sm:flex-row gap-4">
                  <Button variant="hero" size="xl" asChild>
                    <Link to="/quote" onClick={() => trackCTA("Request a Free Quote")}>
                      Request a Free Quote
                      <ArrowRight className="h-5 w-5" />
                    </Link>
                  </Button>
                  <Button variant="hero-secondary" size="xl" asChild>
                    <a href="tel:1-888-315-7225" onClick={() => trackCTA("Call 1-888-315-RACK")}>
                      <Phone className="h-5 w-5" />
                      1-888-315-RACK
                    </a>
                  </Button>
                </div>
             </div>
 
             {/* Quick contact form preview */}
             <div className="bg-card rounded-2xl p-6 md:p-8 shadow-elevated">
               <h3 className="text-xl font-bold text-foreground mb-4">Quick Contact</h3>
               <div className="space-y-4">
                 <div>
                   <label className="block text-sm font-medium text-foreground mb-1.5">Name</label>
                   <input 
                     type="text" 
                     placeholder="Your name"
                     className="w-full px-4 py-3 rounded-lg border border-border bg-background text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-accent"
                   />
                 </div>
                 <div>
                   <label className="block text-sm font-medium text-foreground mb-1.5">Email</label>
                   <input 
                     type="email" 
                     placeholder="your@email.com"
                     className="w-full px-4 py-3 rounded-lg border border-border bg-background text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-accent"
                   />
                 </div>
                 <div>
                    <label htmlFor="cta-service-select" className="block text-sm font-medium text-foreground mb-1.5">What do you need?</label>
                    <select id="cta-service-select" className="w-full px-4 py-3 rounded-lg border border-border bg-background text-foreground focus:outline-none focus:ring-2 focus:ring-accent">
                     <option>New Racking Quote</option>
                     <option>Used Racking Quote</option>
                     <option>Sell My Racking</option>
                     <option>Installation Services</option>
                     <option>Inspection Services</option>
                   </select>
                 </div>
                 <Button variant="accent" size="lg" className="w-full">
                   <MessageSquare className="h-4 w-4" />
                   Send Message
                 </Button>
               </div>
             </div>
           </div>
         </motion.div>
       </div>
     </section>
   );
 }